import SeedQualityComponent from './components/SeedQualityComponent';

window.addEventListener('vue-init', () => {
    mountVueComponent('seed-quality', SeedQualityComponent);
})

if (typeof(mountVueComponent) == 'function') {
    mountVueComponent('seed-quality', SeedQualityComponent);
}
